<template>
    <div class="item-attachments">
        <ul v-for="(attachment, index) in attachments" :key="index">
            <li>
                <a @click="downloadFile(attachment)" href="javascript:;">
                    <i :class="mimeToIcon(attachment.mime)"></i> {{ attachment.name }}
                </a>
            </li>
        </ul>
    </div>
</template>
<!---------------------------------------------------------------------------->
<script>
// import log from 'src/services/logger';
const logTag = "ItemAttachments";

export default {
    name : logTag,

    props : {
        attachments : { type : Array, default : () => [] },
    },

    methods : {
        mimeToIcon(mime) {
            switch (mime) {
                case "application/pdf":
                    return "fa fa-file-pdf-o";
                default:
                    return "fa fa-file";
            }
        },

        downloadFile(attachment) {
            this.$store.dispatch("requestDownloadToken", attachment.id)
                .then((response) => {
                    window.open(attachment.path + '?download=' + response.data.download, '_blank');
                })
        }
    }
};
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
</style>
